import { Component, Inject } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  NotificacionControllerService,
  NotificacionesModel, NotificacionRoleModel
} from 'api-rest';
import { map } from 'rxjs';
import { Combo } from '../../../../services/combo.service';
import { SnackbarService } from '../../../../services/snackbar.service';
import { SpinnerService } from '../../../../services/spinner.service';
import moment from 'moment';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';

@Component({
  selector: 'lib-notification-dialog',
  templateUrl: './notification-dialog.component.html',
  styleUrls: ['./notification-dialog.component.scss'],
})
export class NotificationDialogComponent {

  notificacion: any;
  newItem: boolean = true;
  formGroup!: FormGroup;
  roles: Combo[] = [];
  editMode = false;
  defaultFilter: boolean = true;

  // Array de roles generado dinámicamente a partir del enumerado NotificacionRoleModel.RoleEnum
  rolesList: Array<{key: string, value: string}> = [];

  constructor(
    @Inject('environment') private environment: any,
    public dialogRef: MatDialogRef<NotificationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private notificationService: NotificacionControllerService,
    private snackbarService: SnackbarService,
    public spinnerSrv: SpinnerService,
    @Inject('EmpusaAuthenticationService') private authService: EmpusaAuthenticationService,
  ) {
    this.notificacion = this.data?.item;
    this.newItem = !this.notificacion?.id;
    this.editMode = this.data?.editMode || this.newItem;
    
  }

  ngOnInit(): void {
    this.initializeForm();
    this.generateRolesList();
    if(this.editMode && this.notificacion?.id){
      this.buscarRolesNotificacion();
    }
  }

  initializeForm() {
    this.formGroup = this.formBuilder.group({
      rol: [
        { value: null, disabled: false },
       { validators: Validators.compose([Validators.required]) },
      ],
      fechaDesde: [
        { value: this.notificacion?.fechaDesde, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      fechaHasta: [
        { value: this.notificacion?.fechaHasta, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      mensaje: [
        { value: this.notificacion?.mensaje, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
    });

    if (!this.editMode) {
      this.formGroup.disable();
    }
  }

  private generateRolesList(): void {
    // Obtener todos los valores del enumerado RoleEnum
    const roleEnumValues = Object.values(NotificacionRoleModel.RoleEnum);
    
    this.roles = roleEnumValues.map(role => ({
      id: role,
      name: role
    }));
  }

  guardar() {
    this.formGroup.markAllAsTouched();
    this.formGroup.updateValueAndValidity();

    if (this.formGroup.valid) {
      const fechaDesde = new Date(this.formGroup.get('fechaDesde')?.value);
      fechaDesde.setHours(0, 0, 0, 0);
      const fechaHasta = new Date(this.formGroup.get('fechaHasta')?.value);
      fechaHasta.setHours(0, 0, 0, 0);
      if(fechaHasta < fechaDesde){
        this.snackbarService.showSnackBar(
          'La fecha hasta debe ser igual o posterior a la fecha desde.',
          'error'
        );
        return;
      }
      const rolesSel = this.formGroup.get("rol")?.value.map((item:any) => item.name);
      const formValue = this.formGroup.value;
      const notificationPayload: any = formValue;
      notificationPayload.fechaDesde = moment(notificationPayload.fechaDesde).format('YYYY-MM-DD');
      notificationPayload.fechaHasta = moment(notificationPayload.fechaHasta).format('YYYY-MM-DD');
      //crear o modificar la notificacion
      let request, successMsg: string, errorMsg: string;
      if(this.notificacion){
        request = this.notificationService.actualizarNotificacion(
          this.notificacion.id,
          rolesSel,
          this.notificacion.id,
          notificationPayload.fechaDesde,
          notificationPayload.fechaHasta, 
          notificationPayload.mensaje,
          this.authService.getCurrentUserName()
        );
        successMsg = 'La notificación se ha editado correctamente.';
        errorMsg = 'Ha ocurrido un error al editar la notificación.';
      }else{
        request = this.notificationService.subirNotificacion(
          rolesSel,
          notificationPayload.id, 
          notificationPayload.fechaDesde,
          notificationPayload.fechaHasta, 
          notificationPayload.mensaje, 
          this.authService.getCurrentUserName()
          );
        successMsg = 'La notificación se ha creado correctamente.';
        errorMsg = 'Ha ocurrido un error al crear la notificación.';
      }
      
      
      this.spinnerSrv.loadingShow();
      request.subscribe({
        next: (response) => {
          this.spinnerSrv.loadingHide();
          this.dialogRef.close(true);
          this.snackbarService.showSnackBar(successMsg, 'success');
        },
        error: () => {
          this.spinnerSrv.loadingHide();
          this.snackbarService.showSnackBar(errorMsg, 'error');
        },
      });


    } else {
      this.snackbarService.showSnackBar(
        'Debe completar los campos obligatorios.',
        'error'
      );

    }
  }

  buscarRolesNotificacion(){
    this.spinnerSrv.loadingShow();
    this.notificationService.findAllRoles(this.notificacion.id)
      .subscribe({
        next: (data: any) => {
          this.spinnerSrv.loadingHide();
          if (data) {
            const documRolNames = data.map((item:any) => item.role);
            
            const filteredRoles = this.roles.filter(role => documRolNames.includes(role.name));
            this.formGroup?.get("rol")?.setValue(filteredRoles);
          }
        },
        error: (error) => {
          this.spinnerSrv.loadingHide();
          this.snackbarService.showSnackBar(
            'Error obteniendo listado de roles de notificación',
            'error'
          );
        },
      });
  }
  
  cerrar(): void {
    this.dialogRef.close(null);
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.formGroup.controls[controlName].hasError(errorName) &&
      this.formGroup.controls[controlName].touched
    );
  }

  
}
